<template>
    <button class="button-default"
            :disabled="disabled"
            v-bind:class="[{'btn-disabled': disabled}, {'btn-outlined': outlined}, {'btn-small': small}, {'btn-cart': btnCart},
            {'slimMode': isSlimMode()}, {'alternativeLayout': isAlternativeLayout()}, {'btn-outlined-gom': layoutGom},
            {'btn-payment-gom': paymentButtonGom}, {'btn-green': green}, {'androidMode': isAndroidMode()}]"
            @click="handleClick()">
            <span :class="{'single-line': singleLine, 'fix-icon': icon}">{{ text }}</span>
            <img v-if="icon != null" :src="icon">
    </button>
</template>

<script>
import Util from '@/assets/libs/util'
export default {
  name: 'DefaultButton',
  props: [
    'text',
    'icon',
    'disabled',
    'outlined',
    'small',
    'btnCart',
    'onClick',
    'singleLine',
    'layoutGom',
    'paymentButtonGom',
    'green'
  ],
  methods: {
    handleClick: function () {
      this.$emit('defaultBtnClick')
    },
    isSlimMode: function () {
      return Util.isSlimMode()
    },
    isAlternativeLayout: function () {
      return Util.getLocalConfigs('useAlternativeLayout')
    },
    isAndroidMode: function () {
      return Util.isAndroidMode()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../../assets/common.less");

    .btn-disabled {
      background-color: #CCC !important;
    }

    .button-default {
        height: 50px;
        min-width: 120px !important;
        border-radius: 10px;
    }

    img {
        width: 18px;
        height: auto;
        margin: auto;
        // add weight to the svgicon
      }

    span {
        font-size: 16px;
        overflow: hidden;
        font-weight: 600;
        // font-weight: lighter;
    }

    .fix-icon {
        margin-right: 15px;
    }

    .single-line {
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .btn-outlined, .btn-outlined-gom {
        border: solid 1px;
    }

    .btn-payment-gom {
        margin-left: auto;
        margin-right: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        border-radius: 60px;
        width: 220px;
        min-width: unset;
        height: 220px;
        box-shadow: 3px 3px 3px rgb(88, 85, 85);
        img {
            width: 60%;
            height: auto;
            max-height: 80%;
            padding-top: 20px;
        }
        span {
            font-weight: normal;
            font-size: 1.5ch;
            width: 100%;
            height: max-content;
            .androidMode {
                .button-default {
                    min-width: 210px;
                    height: 5rem;
                }
                img {
                    width: 3rem;
                }

                span {
                    font-size: 20px;
                }
            }
        }
    }

    @media (max-width: 698px) {
        .button-default.btn-payment-gom {
            width: 120px !important;
            min-width: unset !important;
            border-radius: 35px;
            height: 110px;
            span {
                font-size: 13px !important;
            }
            img {
                width: 62% !important;
                height: auto !important;
                max-height: 70% !important;
                padding-top: 10px !important;
            }
        }
    }
</style>
